<template>
  <div v-if="info != null">
    <div class="tabs" v-if="info.is_owner">
      <div
        :class="current == 0 ? 'tab-item current' : 'tab-item'"
        @click="changeTab(0)"
      >
        全部({{ info.total }})
      </div>
      <div
        :class="current == 1 ? 'tab-item current' : 'tab-item'"
        @click="changeTab(1)"
      >
        {{ info.deliver_way == 0 ? "未核销" : "未发货" }}({{ info.unhandle }})
      </div>
    </div>

    <div class="wrapper">
      <div v-if="info.is_owner || info.is_admin">
        <div class="prize-bd" :key="index" v-for="(item, index) in info.list">
          <div class="prize-item">
            <div class="prize-title">
              <div class="prize-user-bd">
                <img class="avatar" :src="item.avatar" />
                <div class="name">{{ item.name }}</div>
              </div>
              <div>
                {{ item.t_submit }} 得分:{{ item.score }}分 用时:{{
                  item.duration
                }}
              </div>
              <div class="address" v-if="item.logistics.mobile">
                <p class="notice">
                  {{ item.logistics.name + " " + item.logistics.mobile }}
                </p>
                <p class="notice">{{ item.logistics.address }}</p>
                <div
                  class="copy"
                  v-clipboard:success="onCopy"
                  v-clipboard:copy="
                    item.logistics.name +
                      ', ' +
                      item.logistics.mobile +
                      '\n' +
                      item.logistics.address
                  "
                >
                  复制内容
                </div>
              </div>
              <div class="address" v-else-if="item.deliver_way == 1">
                暂未填写收货信息
              </div>
            </div>
            <div>
              <div
                class="btn-blue"
                @click="awardVerify(1, index)"
                v-if="item.status == 0 || item.status == 1"
              >
                {{ item.deliver_way == 0 ? "核销" : "发货" }}
              </div>
              <div
                class="btn-blue btn-disabled"
                @click="awardVerify(0, index)"
                v-else
              >
                {{ item.deliver_way == 0 ? "取消核销" : "取消发货" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!info.is_owner && !info.is_admin">
        <div
          class="prize-bd my-awards"
          :key="index"
          v-for="(item, index) in info.list"
        >
          <div class="prize-item" style="padding-right: 0">
            <img class="avatar" :src="item.avatar" />
            <div class="prize-user-name">
              <div class="name">{{ item.name }}</div>
              <div>{{ item.t_submit }}</div>
            </div>
            <div class="score">
              <div>{{ item.score }}</div>
              <span class="duration">{{ item.duration }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="no-data" v-if="info.list.length == 0">暂无记录</div>

      <div class="empty"></div>
    </div>
  </div>
</template>

<script>
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
import {
  getToken,
  formatDate,
  formatMinute,
  setShareInfo,
  reLogin
} from "@/utils/common";
import NavBar from "@/components/navbar";

export default {
  components: { NavBar },
  data() {
    return {
      current: 0,
      info: null,
      page: 1,
      count: 9999,
      qid: "",
      award_id: ""
    };
  },
  methods: {
    onCopy() {
      Toast("复制成功");
    },
    getAwards() {
      let param = {
        award_id: this.award_id,
        page: 1,
        count: 9999,
        qid: this.qid,
        access_token: getToken(),
        type: this.current * 1
      };
      questionOnly.get("/xcx/ques/v2/award/user/list", param).then(res => {
        if (res.sta == 0) {
          let d = res.data;
          for (let i in d.list) {
            let item = d.list[i];
            item.t_submit = formatDate(
              item.t_submit * 1000,
              "yyyy-MM-dd HH:mm"
            );
            item.duration = formatMinute(item.duration);
          }
          this.info = d;
        }else if(res.sta === -500) {
          reLogin();
        }else {
          Toast(res.msg);
        }
      });
    },
    awardVerify(status, index) {
      let rid = this.info.list[index].rid;
      let url =
        this.info.deliver_way == 1
          ? "/xcx/ques/v2/award/verify"
          : "/xcx/ques/v2/award/delivery";
      let param = {
        access_token: getToken(),
        rid,
        status
      };
      questionOnly.post(url, param).then(res => {
        if (res.sta == 0) {
          this.info.list[index].status = status == 0 ? 0 : 2;
        }else if(res.sta === -500) {
          reLogin();
        }else {
          Toast(res.msg);
        }
      });
    },
    changeTab(index) {
      this.current = index * 1;
      this.getAwards();
    }
  },
  mounted() {
    let { award_id = "", qid = "", deliver_way = 0 } = this.$route.query;
    this.qid = qid;
    this.award_id = award_id;
    this.deliver_way = deliver_way;
    this.getAwards();
    setShareInfo(false);
  }
};
</script>

<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.tabs {
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 2px solid #e0e0e0;
}
.tab-item {
  flex: 1;
  height: rem(80);
  line-height: rem(80);
  text-align: center;
  font-size: rem(30);
  color: #999;
}
.tab-item.current {
  position: relative;
  color: #1890ff;
}
.tab-item.current::before {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  content: "";
  width: rem(120);
  height: rem(6);
  border-radius: rem(10);
  background-color: #1890ff;
}

.wrapper {
  overflow: hidden;
  box-sizing: content-box;
  padding-bottom: env(safe-area-inset-bottom);
}

.prize-bd {
  background: #fff;
  margin-top: rem(20);
}
.empty {
  height: rem(130);
  width: 100%;
}

.right-arrow {
  width: rem(16);
  height: rem(25);
}
.prize-title {
  font-size: rem(30);
  max-width: rem(620);
}
.prize-user-bd {
  display: flex;
  align-items: center;
  height: rem(80);
  font-size: rem(26);
  color: #000;
  margin-bottom: rem(6);
}
.prize-user-bd .name {
  font-size: rem(30);
  color: #000;
  max-width: rem(380);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.avatar {
  width: rem(70);
  height: rem(70);
  border-radius: 50%;
}
.my-awards {
  margin-top: 0;
}
.my-awards .prize-title {
  max-width: rem(480);
}
.prize-title span {
  display: block;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prize-title div {
  color: #999;
  font-size: rem(26);
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prize-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: rem(85);
  padding: rem(30);
}
.prize-item.border-top {
  border-top: 2px solid #e0e0e0;
}
.prize-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.avatar {
  width: rem(70);
  height: rem(70);
  border-radius: 50%;
  margin-right: rem(20);
}
.prize-body .name {
  font-size: rem(28);
  line-height: rem(42);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: rem(480);
}
.time {
  font-size: rem(26);
  color: #999;
  line-height: rem(35);
}
.score-box {
  text-align: center;
}
.score {
  font-size: rem(32);
  font-weight: 900;
  color: #1890ff;
  /* line-height: 48rpx; */
}
.duration {
  font-size: rem(24);
  color: #999;
  line-height: rem(36);
  width: rem(102);
  font-weight: 400;
}

.prize-user-name {
  width: rem(500);
  font-size: rem(24);
  line-height: 1.5;
  color: #999;
}
.name {
  font-size: rem(28);
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.score {
  width: rem(120);
  text-align: center;
}
.score .duration {
  font-size: rem(24);
  color: #999;
}

.no-data {
  line-height: rem(180);
  text-align: center;
  color: #999;
  font-size: rem(30);
}

.btn-blue {
  position: absolute;
  top: rem(30);
  right: rem(30);
  width: rem(130);
  height: rem(48);
  line-height: rem(48);
  color: #fff;
  text-align: center;
  font-size: rem(24);
  background: #1890ff;
  border-radius: rem(4);
}
.btn-disabled {
  color: #999;
  background: #eee;
}

.address {
  font-size: rem(26);
  line-height: 1.5;
  color: #999;
  width: rem(690) !important;
}
.notice {
  color: #262626;
}
.address span {
  color: #333;
}
.address .copy {
  color: #1890ff;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/award/detail.vue